import LoadingSvg from '../assets/loading.svg'

function Loading() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-secondary-50 flex items-center justify-center px-4">
      <div className="relative w-full max-w-xl">
        <div className="absolute -top-12 -left-10 w-24 h-24 bg-primary-600/10 rounded-2xl rotate-12 blur-xl" />
        <div className="absolute -bottom-10 -right-8 w-32 h-32 bg-secondary-600/10 rounded-full blur-2xl" />

        <div className="relative bg-white/90 backdrop-blur-lg border border-gray-200 shadow-2xl rounded-3xl p-8 sm:p-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-600 to-secondary-600 flex items-center justify-center shadow-md">
              <span className="text-white font-bold text-sm">S</span>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-gray-500">SAN LMS</p>
              <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Preparing your content</h1>
            </div>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-6">
            <div className="w-32 h-32 sm:w-36 sm:h-36 rounded-2xl bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center border border-gray-200 shadow-sm">
              <img src={LoadingSvg} alt="Loading" className="w-20 h-20 animate-pulse" />
            </div>

            <div className="flex-1 w-full">
              <p className="text-sm text-gray-600">Please wait while we fetch your learning data.</p>
              <div className="mt-4 h-2.5 w-full bg-gray-100 rounded-full overflow-hidden">
                <div className="h-full w-2/3 bg-gradient-to-r from-primary-600 via-secondary-600 to-primary-600 animate-[pulse_1.8s_ease-in-out_infinite]" />
              </div>
              <div className="mt-4 grid grid-cols-3 gap-3">
                <div className="h-10 rounded-lg bg-gray-100 animate-[pulse_1.8s_ease-in-out_infinite]" />
                <div className="h-10 rounded-lg bg-gray-100 animate-[pulse_1.8s_ease-in-out_infinite]" />
                <div className="h-10 rounded-lg bg-gray-100 animate-[pulse_1.8s_ease-in-out_infinite]" />
              </div>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-between text-xs text-gray-500">
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-secondary-600 animate-ping" />
              Syncing student profile
            </span>
            <span>Secured by SAN LMS</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loading